import { useParams, useNavigate } from 'react-router-dom';
import { Button, Space, Dropdown, Typography, Tag, Divider, Spin } from 'antd';
import { CaretDownFilled, EditOutlined, DeleteOutlined, FieldTimeOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import dayjs from 'dayjs';
import { useState } from 'react';

import CertificateModalForm from '../../components/Certificates/CertificateModalForm';
import certificateStore from '../../store/CertificateStore';
import employeeStore from '../../store/EmployeeStore';

const { Text } = Typography;

const getDeadlineTag = (certificate) => {
  if (!certificate.hasDeadline) {
    return { color: 'blue', text: 'Бессрочно' };
  }

  const deadline = dayjs(certificate.expired);
  const now = dayjs();

  const diffDays = deadline.diff(now, 'day');
  const diffMonths = deadline.diff(now, 'month', true);

  if (diffDays < 0) {
    return { color: 'red', text: 'Просрочено' };
  } else if (diffDays < 7) {
    return { color: 'orange', text: `${diffDays} д` };
  } else if (diffDays < 30) {
    return { color: 'gold', text: `${diffDays} д` };
  } else {
    const months = Math.floor(diffMonths);
    return { color: 'green', text: `${months} мес` };
  }
};

const CertificatePage = observer(() => {
  const { id } = useParams();
  const navigate = useNavigate();
  const certificate = certificateStore.certificates.find((c) => c.id === Number(id));
  const [editModalOpen, setEditModalOpen] = useState(false);

  const handleEdit = () => setEditModalOpen(true);
  const handleDelete = () => {
    if (!certificate) return;
    certificateStore.deleteCertificate(certificate.id);
    navigate(`/certificates`);
  };

  const handleSave = (updatedCert) => {
    if (!certificate) return;
    certificateStore.updateCertificate(certificate.id, updatedCert);
    setEditModalOpen(false);
  };

  if (!certificate) return <div>Удостоверение не найдено</div>;

  const deadlineTag = getDeadlineTag(certificate);

  const items = [
    {
      key: 'edit',
      icon: <EditOutlined />,
      label: 'Изменить',
      onClick: (e) => {
        e.domEvent.stopPropagation();
        handleEdit();
      },
    },
    {
      key: 'delete',
      icon: <DeleteOutlined />,
      label: <span style={{ color: 'red' }}>Удалить</span>,
      onClick: (e) => {
        e.domEvent.stopPropagation();
        handleDelete();
      },
    },
  ];

  // Получаем сотрудника, если он есть
  const employee = employeeStore.getEmployeeById(certificate.employeeId);

  return (
    <>
      <Space split={<Divider type="vertical" />} style={{ marginBottom: 20 }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(`/certificates`)}
        />

        <Dropdown placement="bottomRight" menu={{ items }} trigger={['click']}>
          <Button
            type="text"
            onClick={(e) => e.stopPropagation()}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: 0,
              maxWidth: 240,
              minWidth: 0,
            }}
          >
            <Text
              ellipsis
              style={{
                flex: 1,
                minWidth: 0,
                fontWeight: 600,
                fontSize: 16,
                marginRight: 6,
              }}
            >
              {certificate.name || 'Без названия'}
            </Text>
            <CaretDownFilled />
          </Button>
        </Dropdown>
      </Space>
      <br/>
      <Typography>{certificate.info}</Typography>
      <br />
      <Tag icon={<FieldTimeOutlined />} color={deadlineTag.color}>
        {deadlineTag.text}
      </Tag>
      <br />
      <br />

      <Button
        onClick={() => {
          window.open(
            `https://tmgdin.bitrix24.ru/company/personal/user/${certificate.employeeId}/`,
            '_blank'
          );
        }}
      >
        {employee ? employee.name : <Spin size="small" />}
      </Button>

      <Divider orientation="left">Связанные файлы</Divider>
      <Button
        type="primary"
        onClick={() => {
          window.open(
            certificate.bitrixFolder,
            '_blank'
          );
        }}
      >
        Открыть файлы
      </Button>

      <CertificateModalForm
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        certificate={certificate}
        onSave={handleSave}
      />
    </>
  );
});

export default CertificatePage;
